<div class="container-wrapper">
  <h2 matDialogTitle>Create Organization</h2>

  <mat-dialog-content>
    <mat-form-field appearance="fill" style="width: 100%; margin-top: 0.5rem;">
      <mat-label>Organization name</mat-label>
      <mat-icon matPrefix>corporate_fare</mat-icon>
      <input matInput [(ngModel)]="orgName" placeholder="e.g. Ottobock DACH"
        (keyup.enter)="onConfirm()" autocomplete="off" />
    </mat-form-field>

    <div *ngIf="error" style="color: #dc2626; font-size: 0.82rem; margin-top: 0.25rem;">
      <mat-icon style="font-size:1rem; vertical-align:middle;">error_outline</mat-icon>
      {{ error }}
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-flat-button (click)="onClose()" [disabled]="saving">Cancel</button>
    <button mat-raised-button color="primary" (click)="onConfirm()"
      [disabled]="!orgName.trim() || saving">
      <mat-spinner *ngIf="saving" diameter="18"
        style="display:inline-flex; margin-right:6px;"></mat-spinner>
      <mat-icon *ngIf="!saving">add</mat-icon>
      {{ saving ? 'Creating…' : 'Create' }}
    </button>
  </mat-dialog-actions>
</div>